import { refreshFronteggTokens } from '@dtx-company/ithaca-sdk/src'
import { useCallback } from 'react'

export function useRefreshJwt(): () => Promise<void> {
  const refreshFrontegg = useCallback(async () => {
    await refreshFronteggTokens()
  }, [])
  return refreshFrontegg
}
